<template>
  <div class="container" style="background-color: #fff;">
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div style="position: relative; width: 100%;">
      <div class="content">
        <!-- 标题 -->
        <div class="title-ty">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>机制币送评</span>瑕疵代码</div>
        </div>
        <p style="padding: 100px 50px 0; font-weight: bold; font-size: 16px; letter-spacing: 2px; line-height: 30px;">
          钱币存在结构性缺陷、人工处理、铸造问题时，分数后附加数字代码，无缺陷不标注任何代码。一枚钱币多项缺陷时，优先标注影响品相最
          重的一项代码。</p>
        <ul class="biaozhun-list">
          <li class="biaozhun-item" style="height: 160px; position: relative; background-color: #FFFAF4;"
            v-for="item in codeList">
            <div class="code-bj-sum">{{ item.title }}</div>
            <div class="biaozhun-item-title" style="margin-bottom: 20px;">代码 {{ item.title }}</div>
            <div class="biaozhun-item-text" style="position: absolute; left: 30px; top: 70px;">{{ item.tag }}</div>
            <div class="biaozhun-item-text" style="position: absolute; left: 30px; top: 110px;"><span
                style="font-weight: bold; color: #000;">备注：</span>{{ item.text }}</div>
          </li>
        </ul>
      </div>
      <img src="@/assets/image/logo-shuiyin.png" alt=""
        style="width: 300px; position:absolute; bottom: 0px; left: 0px;" />
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      codeList: [
        {
          id: 0,
          title: '00',
          tag: '臆造币，非官方铸币、后铸仿造品种',
          text: '不打分，仅标注00+真品'
        },
        {
          id: 1,
          title: '01',
          tag: '大面积锈蚀、有害PVC污染、包浆过厚遮盖底板',
          text: '边缘极小薄锈(<3mm)可酌情不标码降分'
        },
        {
          id: 2,
          title: '02',
          tag: '人工严重清洗，币面密布擦痕、发丝纹，底板光度受损',
          text: '清洗面积<30%可小幅降分不标码'
        },
        {
          id: 3,
          title: '03',
          tag: '钱币修补(含币面修补、边道缺口修补)',
          text: '任何修补统一标注03'
        },
        {
          id: 4,
          title: '04',
          tag: '人工做旧假包浆、人为上油改色',
          text: '自然层次老包浆不标注04'
        },
        {
          id: 5,
          title: '05',
          tag: '钱币开裂、暗裂、边道残缺、破口',
          text: '先天铸缺除外'
        },
        {
          id: 6,
          title: '06',
          tag: '人为磕碰、划伤、火烧、人工打磨边齿、抛光改品相',
          text: '微小磕碰<1mm可豁免标注'
        },
        {
          id: 7,
          title: '07',
          tag: '先天铸造缺陷:漏铜、铸缺、错坯、天生凹凸',
          text: '出厂自带工艺瑕疵'
        },
        {
          id: 8,
          title: '08',
          tag: '冲压错币:移位、叠压、偏打、坯料失误',
          text: '错版机制币专属代码'
        },
        {
          id: 9,
          title: '09',
          tag: '币面加盖各类人为戳记(钱庄戳、商业戳)',
          text: '老传世原戳统一标注09'
        }
      ]
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  width: 1200px;
  margin: 0 auto;
}

.code-bj-sum {
  font-size: 150px;
  font-weight: bold;
  /* 设置渐变背景 */
  background: linear-gradient(to bottom, #FBF4EE, #FFFAF4);
  /* 把背景裁剪成文字形状，-webkit前缀兼容Safari */
  -webkit-background-clip: text;
  background-clip: text;
  /* 文字透明，露出背景渐变 */
  color: transparent;
  position: absolute;
  right: 20px;
  top: -30px;
  letter-spacing: 2px;
}
</style>